<aside aria-label="Form Editor">
  <h2>{{formHeading}}</h2>
  <form novalidate>
    <div class="grid-x" [ngClass]="{'hide': hideFormNameControl()}">
      <div class="cell small-12">
        <label>
          Form Name:
          <input type="text" class="no-margin" [(ngModel)]="selectedState.name" name="stateName" (ngModelChange)="selectedStateNameChanged($event)" (focus)="preEditStateName=selectedState.name" [ngClass]="{'is-invalid-input':showDuplicateNameWarning}">
        </label>
      </div>
      <div [ngClass]="{'hide': !showDuplicateNameWarning}" class="cell small-12 small-font-size red">Duplicate Form name, please change the form name!</div>
    </div>
    <div class="form-button-group margin-top">
      <button class="button hollow" (click)="cancel()">Cancel</button>
      <button class="button hollow" (click)="edit()" [disabled]="hideFormNameControl()">Edit Form</button>
    </div>
    <hr />
    <h3>Form Flow</h3>
    <div class="grid-x grid-padding-x">
      <div class="cell small-6"><button class="button hollow expanded" [disabled]="disableForStart" (click)="addInputForm()">Add Input Form</button></div>
      <div class="cell small-6"><button class="button hollow expanded" [disabled]="disableForStart" (click)="addEndPoint()">Add End Point</button></div>
      <div class="cell small-6"><button class="button hollow expanded" [disabled]="disableForStart || disableReviewForm" (click)="addReviewForm()">Add Review Form</button></div>
      <div class="cell small-6"><button class="button hollow expanded" [disabled]="disableReviewLevel" (click)="addReviewLevel()">Add Review Level</button></div>
      <div class="cell small-6"><button class="button hollow expanded" [disabled]="disableRedoForStart" (click)="showGotoEditor()">Add Return Link</button></div>
      <div class="cell small-6"><button class="button hollow expanded" [disabled]="disableForStart" (click)="addTransition()">Add Transition</button></div>
    </div>
    <div class="auto cell" [ngClass]="{'hide':!showGotoEditorUI}">
      <label>
        Choose Link Form:
        <select name="slctGoto" (change)="addGotoLink($event.target.value)" [ngModel]="selectedState.key">
          @for (state of availableStates; track state) {
            <option [value]="state.key">{{state.name}}</option>
          }
        </select>
      </label>
    </div>
    @if (showTransitionEditor) {
      <div class="auto cell">
        <label>
          Choose Target State:
          <select name="slctState" (change)="addTransitionLink($event.target.value)">
            @for (state of availableStates; track state) {
              <option [value]="state.key">{{state.name}}</option>
            }
          </select>
        </label>
      </div>
    }
  </form>
</aside>
